import styled, { css } from 'styled-components';
import { AllieButton } from '../../../components/Buttons/Button';
import { AllieCard } from '../../../components/Card';
import { AlliePopover } from '../../../components/Popover';
import { AllieText } from '../../../components/Text';
import { AllieDrawerButton } from '../../../components/Drawer';
import { AllieModal } from '../../../components/Modal';
import { getCssVar } from '../../../common/utils';

const commonStyles = css`
  --color: var(--allie-color-neutral-60);
  --height: 24px;
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: 0;
  --padding-bottom: 0;
  --border-color: none;
  --border-width: 0;
  --border-radius: 0;
  border: 1px solid var(--allie-color-neutral-30);
  border-radius: 4px;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  padding: 6px 4px;
  .allie-text-button-small {
    font-size: 14px;
  }
`;

export const StyledIconButton = styled(AllieButton)`
  background: var(--allie-color-light-main);
  ${commonStyles}
  &:hover {
    color: var(--allie-color-neutral-main);
  }
`;

export const StyledDrawerButton = styled(AllieDrawerButton)`
  ${commonStyles}
`;

export const StyledCard = styled(AllieCard)`
  border-radius: 0;
  box-shadow: none;
  background: none;
  margin: 12px 0 0 0;

  ion-card-content {
    padding: 0;
  }

  .drawer-button-shift-selector {
    ${commonStyles}

    .allie-text-button-small {
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
    }
  }
`;

export const StyledPopover = styled(AlliePopover)<{ isMobile?: boolean }>`
  --width: 380px;
`;

export const StyledMobileModal = styled(AllieModal)<{ isMobile?: boolean }>`
  --height: auto;
  --border-radius: var(--allie-spacing-xl);
  & > .ion-delegate-host {
    max-width: ${(props) => (props.isMobile ? '100vw' : 'unset')};
  }
`;

export const StyledMobileModalContentContainer = styled.div`
  height: 70vh;
`;

export const StyledMobileModalContent = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: var(--allie-spacing-md);
  color: var(--allie-color-neutral-main);
  height: 100%;
  display: flex;
  align-items: center;
`;

export const HalfShiftSelectorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--allie-spacing-md);
`;

export const StyledSection = styled.section<{ isMobile: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.isMobile ? 'space-between' : 'flex-start')};
  flex-direction: ${(props) => (props.isMobile ? 'column' : 'row')};
`;

export const FlexibleContainer = styled.div<{ full: boolean }>`
  display: flex;
  column-gap: 6px;
  align-items: center;

  ${(props) =>
    props.full &&
    css`
      justify-content: space-between;
      width: 100%;
    `}
`;

export const StyledCalendarButtonText = styled(AllieText)`
  @media (min-width: ${() => getCssVar('--breakpoint-desktop-lg', '1600px')}) {
    font-size: 14px !important;
    line-height: 20px !important;
  }

  @media (min-width: ${() => getCssVar('--breakpoint-desktop-xl', '1920px')}) {
    font-size: 16px !important;
    line-height: 22px !important;
  }
`;

export const StyledShiftNameText = styled(AllieText)`
  @media (min-width: ${() => getCssVar('--breakpoint-desktop-lg', '1600px')}) {
    font-size: 18px !important;
    line-height: 25px !important;
  }

  @media (min-width: ${() => getCssVar('--breakpoint-desktop-xl', '1920px')}) {
    font-size: 20px !important;
    line-height: 28px !important;
  }
`;
